import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {BackNavigable, BackNavigationService, SOFTLINE_FEATURE_TITLE, TitleStore} from '@softline/application';
import {Store} from '@softline/core';
import {Router, RouterModule} from '@angular/router';

@Component({
    selector: 'lib-kunden-konditionsliste',
    imports: [RouterModule],
    templateUrl: './kunden-konditionsliste.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./kunden-konditionsliste.component.css']
})
export class KundenKonditionslisteComponent implements OnInit, OnDestroy, BackNavigable {

  constructor(
    private store: Store,
    protected router: Router,
    private backNavigationService: BackNavigationService) { }

  ngOnInit(): void {
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '#KUNDEN_KONDITIONSLISTE.TITLE');
    this.backNavigationService.set(this);
  }

  ngOnDestroy(): void {
    this.backNavigationService.set(undefined);
    this.store.commit(SOFTLINE_FEATURE_TITLE, TitleStore.mutations.setTitle, '');
  }

  async navigateBack(): Promise<void> {
    await this.router.navigate(['/']);
  }
}
